import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ClientDiagnosticsService } from '../services/client-diagnostics.service';

/**
 * Build the route *configuration* path — `/oncology/patients/:id/protocol/:protocolId`
 * — by walking the activated route tree and joining each level's `routeConfig.path`.
 *
 * Deliberately not `router.url`, which is the resolved URL and therefore
 * carries real patient and protocol ids. The config path is masked by
 * construction: there is no identifier in it to leak.
 */
function toConfigPath(snapshot: ActivatedRouteSnapshot): string {
  const segments: string[] = [];

  for (
    let route: ActivatedRouteSnapshot | null = snapshot;
    route;
    route = route.firstChild
  ) {
    const path = route.routeConfig?.path;
    if (path) segments.push(path);
  }

  return `/${segments.join('/')}`;
}

/**
 * Keeps `ClientDiagnosticsService` aware of which screen the user is on, so a
 * ticket filed from a clinical view carries that view's identity without the
 * reporter having to describe it.
 */
export function provideClientDiagnostics(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const router = inject(Router);
      const diagnostics = inject(ClientDiagnosticsService);

      router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          diagnostics.setRoutePath(toConfigPath(router.routerState.snapshot.root));
        });
    }),
  ]);
}
